import $ from "jquery";
import _ from "underscore";

const Utils = {};

Utils.openWindow = function (options) {
  if (!options || !options.url) return;
  var winHeight = $(window).height();
  var winWidth = $(window).width();
  var height = Math.max(400, options.height || winHeight - 50);
  var minWidth = options.minWidth || 400;
  var maxWidth = options.maxWidth || 1200;
  var width = Math.max(
    minWidth,
    Math.min(maxWidth, options.width || winWidth - 50)
  );
  const win = window.open(
    options.url,
    options.title || "asModal",
    "height=" + height + ",width=" + width + ",resizable=yes,scrollbars=yes"
  );
  win.moveTo((winWidth - width) / 2, (winHeight - height) / 2);
  win.focus();
};

Utils.escape_with_br = function (str) {
  return _.escape(str).replace(/\n/g, "<br>");
};

Utils.pluralize = function (val, sing, plur, sep) {
  sep = sep || " ";
  return val + sep + (val == 1 ? sing : plur);
};
Utils.pluralize_word = function (word) {
  return word.length && word.substr(-1) != "s" ? word + "s" : word;
};

Utils.addZero = function (nr) {
  return nr < 10 ? "0" + nr : nr;
};

Utils.round_number = function (val) {
  if (isNaN(val)) return 0;
  else return Math.round(val * 100) / 100;
};

Utils.to_number = function (val) {
  if (isNaN(val)) return 0;
  else return parseFloat(val) || 0;
};

Utils.nl2br = function (val) {
  return val.replace(/(?:\r\n|\r|\n)/g, "<br />");
};

Utils.replaceTags = function (val, string) {
  return val.replace(/<(\s*\/?)[^>]+>/g, string);
};

Utils.stripTagsButBr = function (val) {
  return val.replace(/<(?!br\s*\/?)[^>]+>/g, "");
};

Utils.stripTagsBut = function (val) {
  var _tags = [];
  var _tag = "";
  for (var _a = 1; _a < arguments.length; _a++) {
    _tag = arguments[_a].replace(/<|>/g, "").trim();
    if (arguments[_a].length > 0) _tags.push(_tag, "/" + _tag);
  }

  if (!(typeof val == "string") && !(val instanceof String)) return "";
  else if (_tags.length == 0) return val.replace(/<(\s*\/?)[^>]+>/g, "");
  else {
    var _re = new RegExp("<(?!(" + _tags.join("|") + ")s*/?)[^>]+>", "g");
    return val.replace(_re, "");
  }
};

Utils.formatTime = function (hours, minutes, seconds) {
  seconds = parseInt(seconds || 0);
  minutes = parseInt(minutes || 0);
  hours = parseInt(hours || 0);
  minutes += Math.floor(seconds / 60);
  seconds = seconds % 60;
  hours += Math.floor(minutes / 60);
  minutes = minutes % 60;
  return Utils.addZero(hours) + ":" + Utils.addZero(minutes);
};

Utils.timeToMinutes = function (time) {
  // Converts a time string ("14:30") to minutes
  var times = time.split(":");
  if (!times.length) {
    return 0;
  } else if (times.length == 1) {
    return times[0];
  } else {
    return parseInt(times[0]) * 60 + parseInt(times[1]);
  }
};

Utils.createGuid = function () {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

Utils.format_date = function (format_string, date) {
  var date_markers = {
    d: [
      "getDate",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    a: [
      "getDate",
      function (v) {
        var l = v.toString().substr(-1);
        return l === "1" || l === "2" ? v + ":a" : v + ":e";
      },
    ],
    j: ["getDate"],
    m: [
      "getMonth",
      function (v) {
        return Utils.addZero(v + 1);
      },
    ],
    F: [
      "getMonth",
      function (v) {
        return Schedule.month_names[v];
      },
    ],
    n: [
      "getMonth",
      function (v) {
        return Schedule.month_names_short[v];
      },
    ],
    l: [
      "getDay",
      function (v) {
        return Schedule.day_names[v];
      },
    ],
    w: [
      "getDay",
      function (v) {
        return Schedule.day_names_short[v];
      },
    ],
    y: ["getFullYear"],
    H: [
      "getHours",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    M: [
      "getMinutes",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    S: [
      "getSeconds",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    i: ["toISOString "],
  };
  return format_string.replace(/%(.)/g, function (m, p) {
    var rv = date[date_markers[p][0]]();
    if (date_markers[p][1] != null) rv = date_markers[p][1](rv);
    return rv;
  });
};
Utils.format_utc_date = function (format_string, date) {
  var date_markers = {
    d: [
      "getUTCDate",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    j: ["getUTCDate"],
    m: [
      "getUTCMonth",
      function (v) {
        return Utils.addZero(v + 1);
      },
    ],
    F: [
      "getUTCMonth",
      function (v) {
        return Schedule.month_names[v];
      },
    ],
    n: [
      "getUTCMonth",
      function (v) {
        return Schedule.month_names_short[v];
      },
    ],
    l: [
      "getUTCDay",
      function (v) {
        return Schedule.day_names[v];
      },
    ],
    w: [
      "getUTCDay",
      function (v) {
        return Schedule.day_names_short[v];
      },
    ],
    y: ["getUTCFullYear"],
    H: [
      "getUTCHours",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    M: [
      "getUTCMinutes",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    S: [
      "getUTCSeconds",
      function (v) {
        return Utils.addZero(v);
      },
    ],
    i: ["toISOString "],
  };
  return format_string.replace(/%(.)/g, function (m, p) {
    var rv = date[date_markers[p][0]]();
    if (date_markers[p][1] != null) rv = date_markers[p][1](rv);
    return rv;
  });
};

Utils.format_date_string = function (date) {
  date = new Date(date);
  return Utils.format_date("%j %n", date);
};

Utils.format_recently_date_string = function (date) {
  date = new Date(date);
  const diffDays = (new Date() - date) / (60 * 60 * 24 * 1000);
  return Utils.format_date(
    diffDays > 365 ? "%a %n %y" : diffDays > 7 ? "%a %n" : "%l",
    date
  );
};

Utils.format_date_time_string = function (date) {
  date = new Date(date);
  return Utils.format_date("%j %n %H:%M", date);
};

Utils.showFullscreenSpinner = function (message, title) {
  var spinner =
    '<div id="full-page-spinner">' +
    (title ? "<h3>" + title + "</h3>" : "") +
    (message ? '<p id="fullscreen-spinner-msg">' + message + "</p>" : "") +
    '<div class="spinner"><div class="sk-spinner sk-spinner-three-bounce">' +
    '<div class="sk-bounce1"></div><div class="sk-bounce2"></div>' +
    '<div class="sk-bounce3"></div></div></div></div>';
  $("body").append(spinner);
  return $(spinner);
};

Utils.hideFullscreenSpinner = function () {
  $("#full-page-spinner").remove();
};

Utils.getInboxAllowedTags = () => {
  return "b,strong,i,em,ul,li,ol,br,p,a";
};

Utils.formatRichTextOutput = (message) => {
  let allowedTags = Utils.getInboxAllowedTags().split(",");
  return Utils.stripTagsBut(message, ...allowedTags);
};

Utils.formatSubMessage = (message) => {
  let formattedMessage = message;
  formattedMessage = Utils.stripTagsBut(formattedMessage, "p", "br");
  formattedMessage = Utils.replaceTags(formattedMessage, " ");
  formattedMessage = formattedMessage.substr(0, 100);
  return formattedMessage;
};

Utils.getTinyMCELanguage = () => {
  return S.session.user.sp_account.language === "sv" ? "sv_SE" : "en_US";
};

Utils.getTinyMCEOptions = () => {
  const editorOptions = {
    autoresize_bottom_margin: 0,
    browser_spellcheck: true,
    content_css: tinyCssPath,
    contextmenu: false,
    max_height: 300,
    menubar: false,
    skin: "tinymce-5",
    statusbar: false,
  };
  const language = Utils.getTinyMCELanguage();
  if (language !== "en_US") {
    editorOptions.language = language;
  }
  return editorOptions;
};

export default Utils;
